import { Flex, Icon, Text } from "@chakra-ui/react"
import type { FC } from "react"

import CardContainer from "common/components/CardContainer"
import Link from "common/components/Link"
import { SquareArrowUpRight } from "ui/components/icons/font-awesome/SquareArrowUpRight"
import { getOrganizationClaimHelpLinks } from "whitelabel/constants/helps"
import type { Organization } from "query/graphql"

type Props = {
  organization: Organization
  title: string
}
const HelpLinks: FC<Props> = ({ organization, title }) => {
  const helps = getOrganizationClaimHelpLinks(organization.id)

  if (!helps?.length) return null

  return (
    <CardContainer isFullHeightView isTableView title={title}>
      {helps.map((help) => (
        <Link key={`help_${help.title}`} isExternal href={help.href} w="full">
          <Flex
            align="center"
            borderBottomColor="gray.200"
            borderBottomWidth="1px"
            borderStyle="solid"
            direction="row"
            h={12}
            justifyContent="space-between"
            px={6}
            w="full"
          >
            <Text fontSize="sm">{help.title}</Text>
            <Icon as={SquareArrowUpRight} h={4} w={4} />
          </Flex>
        </Link>
      ))}
    </CardContainer>
  )
}

export default HelpLinks
